var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 0L16 16L0 16L0 0L16 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 0L16 16L0 16L0 0L16 0L16 0Z",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 0L16 16L0 16L0 0L16 0Z",
    id: "up",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask-Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 0L16 16L0 16L0 0L16 0L16 0Z",
    id: "path_1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 0L16 16L0 16L0 0L16 0L16 0Z",
    id: "up#1",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5L6 0",
    id: "Line",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line-2",
    transform: "translate(6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L6 5",
    id: "Line",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.53a6a3c76c689af08bbd6f6516b5f3d0.svg";
export { ForwardRef as ReactComponent };